import { Reducer } from '@reduxjs/toolkit';

const issuesViewTypeReducer: Reducer = (
  state, { payload },
) => (
  {
    ...state,
    issuesViewType: payload,
  }
);

export default issuesViewTypeReducer;
